
import { Backdrop, Theme, makeStyles, createStyles, useTheme } from "@material-ui/core";

import { WhisperSpinner } from 'react-spinners-kit';

export interface PageLoaderProps {
    Label?: string,
    IsLoading: boolean
};


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        },
    }),
);
export default function PageLoader(props: PageLoaderProps) {
    const { Label, IsLoading } = props;
    const classes = useStyles();
    const theme = useTheme();
    //assigning default label     
    var tempLabel = Label;
    if (!tempLabel) {
        tempLabel = "Please wait";
    }

    const loaderSetting = {
        color: theme.palette.mode === 'dark' ? theme.palette.dark.light : theme.palette.primary.main
    }

    return (

        // <Dialog
        //     open={IsLoading}
        //     color="transparent"
        // // PaperProps={{
        // //   style: {
        // //     backgroundColor: 'transparent',
        // //     boxShadow: 'none',
        // //   },
        // // }}          
        // >

        //     <DialogContent>
        //         <div style={{ textAlign: "center" }}>
        //             <WhisperSpinner size={50} />
        //         </div>
        //     </DialogContent>
        // </Dialog>

        <Backdrop open={IsLoading} className={classes.backdrop} >
            <WhisperSpinner size={60} backColor={loaderSetting.color} frontColor={loaderSetting.color} {...loaderSetting} />
        </Backdrop>
    )
}
